<template>
    <div class="result-hero" :style="{'background-image': backgroundImage}">
        <div class="result-hero__wrapper">
            <div class="result-hero__location">
                <location-info :data="locationInfo"></location-info>
            </div>
        </div>
        <order-progress :step="1"></order-progress>
    </div>
</template>

<script type="text/javascript">
    import LocationInfo from './location-info.vue';
    import OrderProgress from './order-progress.vue';
    export default {
        computed: {
            locationInfo() {
                let destinationData = this.$store.state.destination;
                let travelQueryData = this.$store.getters.travelQuery;
                console.log(travelQueryData);

                return Object.assign({}, destinationData, travelQueryData);
            },
            backgroundImage() {
                if(this.locationInfo.image) {
                    return 'url(' + this.locationInfo.image + ')';
                }

                return '';
            }
        },
        components: {
            'location-info': LocationInfo,
            'order-progress': OrderProgress
        }
    }
</script>